import { HStack } from '@direct-frontend/components';
import { Outlet } from '@direct-frontend/modules-router';
import styles from './DashboardLayout@desktop.module.css';

const DashboardLayout = () => (
    <HStack className={styles.container} gap="8">
        <main className={styles.content}>
            <div className={styles.innerContent}>
                <Outlet />
            </div>
        </main>
    </HStack>
);

export default DashboardLayout;
